document.addEventListener('DOMContentLoaded', () => {
    // animated-text-section
    const animatedTextWrappers = document.querySelectorAll('.animated-text-wrapper');
    animatedTextWrappers.forEach((wrapper) => {
        const sectionId = wrapper.dataset.sectionId;
        // const header = document.getElementById(`${sectionId}-animated-text`);
        
        const header = wrapper.querySelector('.animated-text-showing');

        const hiddenTexts = wrapper.querySelectorAll('.hidden-text');
        const texts = Array.from(hiddenTexts).map(textElement => textElement.dataset.text);

        let index = 0;

        function loopText() {
            header.innerHTML = texts[index];
            index = (index + 1) % texts.length;
        }

        setInterval(loopText, 1000); // change text every second
    });
});